module.exports = __webpack_public_path__ + "img/Z82_10.0fe08c17.jpg";